import { render, staticRenderFns } from "./InputConsent.vue?vue&type=template&id=dda659e0&scoped=true&"
import script from "./InputConsent.vue?vue&type=script&lang=ts&"
export * from "./InputConsent.vue?vue&type=script&lang=ts&"
import style0 from "./InputConsent.vue?vue&type=style&index=0&id=dda659e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda659e0",
  null
  
)

export default component.exports